import { inject, NgZone } from '@angular/core';
import { PermissionResource } from '@coin/shared/core/util-enums';
import { combineLatest, filter, map, Observable, take, tap } from 'rxjs';
import { PermissionsService } from './permissions.service';
import { UserState } from './user.state';
import { RoleGuardData } from './role-guard.service';
import { Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { ToastrService } from 'ngx-toastr';

export const canActivateRoleGuard = (requiredResources?: RoleGuardData[]) => (): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const store = inject(Store);
  const ngZone = inject(NgZone);
  const toast = inject(ToastrService);
  const permissionsService = inject(PermissionsService);

  return combineLatest([store.select(UserState.accessViews), store.select(UserState.allPermissions)]).pipe(
    filter(([access, permissions]) => !!access && !!permissions),
    take(1),
    map(() => {
      if (permissionsService.isSuperAdmin()) {
        return true;
      }

      // minimal requirement
      if (!permissionsService.hasPermissions(PermissionResource.CustomerApp)) {
        return false;
      }

      if (!requiredResources?.length) return true;

      // check allowed actions
      return requiredResources.some(resource =>
        permissionsService.hasPermissionsAndActions({ resources: [resource.resource], actions: resource.actions })
      );
    }),
    tap(result => {
      if (!result) {
        toast.error('Not authorized for page.');
        ngZone.run(() => router.navigate(['']));
      }
    })
  );
};
